import { render } from "./LogisticsPage.vue?vue&type=template&id=7cf94213&scoped=true"
import script from "./LogisticsPage.vue?vue&type=script&lang=js"
export * from "./LogisticsPage.vue?vue&type=script&lang=js"

import "./LogisticsPage.vue?vue&type=style&index=0&id=7cf94213&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf94213"]])

export default __exports__